import React from 'react';
import './LoadingIndicatorForApp.css';

const LoadingIndicatorForApp = () => {
  return <div className="LoadingIndicatorForApp"></div>;
};

export default LoadingIndicatorForApp;
